export const factoriesListMock = {
  factories: [
    {
      factory: {
        id: 'ind-pemp-p122',
        name: 'PreeEmpro 122',
      },
      cluster: 'PreeEmpro',
      location: 'India',
      operator_count: 1200,
      sewing_lines: 50,
      product_types: ['SHIRT', 'SKIRT'],
    },
    {
      factory: {
        id: 'ind-pemp-p78',
        name: 'PreeEmpro 78',
      },
      cluster: 'PreeEmpro',
      location: 'India',
      operator_count: 1200,
      sewing_lines: 50,
      product_types: ['SHIRT'],
    },
  ],
};
